<template>
  <div class="stream-tab-body">
    <div class="stream-tab-body-left-panel">
      <div class="stream-tab-body-left-panel-header">STREAM CREDENTIALS</div>
      <div class="stream-tab-body-left-panel-body">

        <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Allow Stream From Other Source</div>
          </div>
          <div class="stream-details-options">
            <b-switch v-model="form.allowStreamFromOtherSource"> </b-switch>
          </div>
        </div>

        <div v-if="form.allowStreamFromOtherSource" class="stream-settings-widget-option">
          <div class="stream-settings-widget-option-title">Stream URL</div>
          <div class="stream-settings-widget-option-body">
            <div class="stream-settings-option-left-panel">
              <div class="field-value">
                <b-input type="textarea" v-model="form.otherSourceUrl">
                </b-input>
              </div>
            </div>
          </div>
        </div>


        <div v-if="!form.allowStreamFromOtherSource" class="stream-settings-widget-option">
          <div class="stream-settings-widget-option-title">Stream URL</div>
          <div class="stream-settings-widget-option-body">
            <div class="stream-settings-option-left-panel">
              <div class="field-value">
                <input type="text" class="stream-details-input" readonly :value="form.stream_url" />
              </div>
            </div>
            <div class="stream-settings-option-right-panel">
              <div class="stream-details-options">
                <b-button type="is-primary" class="space-top" v-clipboard:copy="form.stream_url"
                  v-clipboard:success="onCopy" v-clipboard:error="onCopyError" outlined>COPY</b-button>
              </div>
            </div>
          </div>


        </div>


        <div v-if="!form.allowStreamFromOtherSource" class="stream-settings-widget-option">
          <div class="stream-settings-widget-option-title">Stream key (Paste in encoder)</div>
          <div class="stream-settings-widget-option-body">
            <div class="stream-settings-option-left-panel">
              <div class="field-value" :class="{ disableAllEvent: streamKey == 'none' }">
                <b-field :type="streamKey == 'none' ? 'is-danger' : ''"
                  :message="streamKey == 'none' ? 'Something went wrong while getting stream key' : ''">
                  <b-input type="password" :disabled="form.stream_key == 'none'"
                    :value="streamKey == 'none' ? '' : form.stream_key" readonly password-reveal>
                  </b-input>
                </b-field>
              </div>
            </div>

            <div class="stream-settings-option-right-panel">
              <div class="stream-details-options">
                <b-button type="is-primary" v-if="form.stream_key != 'none'" v-clipboard:copy="form.stream_key"
                  v-clipboard:success="onCopy" v-clipboard:error="onCopyError" outlined>COPY</b-button>
              </div>
            </div>
          </div>
        </div>


        <div v-if="false && !form.allowStreamFromOtherSource" class="stream-settings-widget-option">
          <div class="stream-settings-widget-option-title" style="margin-bottom: 10px;">
            Stream latency
            <b-tooltip type="is-dark" position="is-right" size="is-small">
              <img width="15" src="@/assets/images/icons/info.svg">
              <template v-slot:content>
                <p>
                  Stream latency is the delay between what your camera captures <br> and when it’s shown to viewers.
                </p>
                <p>
                  Normal has higher quality video and is best if <br> you don’t want to interact with your audience,
                </p>
                <p>
                  low if you want to interact in near real-time.
                </p>
              </template>
            </b-tooltip>
          </div>


          <div class="stream-settings-widget-option-body" style="margin-bottom: 5px;">
            <div class="stream-settings-option-left-panel">
              <div class="field-value">
                <div class="block row">
                  <b-radio v-model="form.stream_latency" name="latency" native-value="normal" :disabled="isPlaying">
                    Normal latency
                  </b-radio>
                  <div class="h-spacer"></div>
                  <b-radio v-model="form.stream_latency" name="latency" native-value="low" :disabled="isPlaying">
                    Low-latency
                  </b-radio>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    <div class="stream-tab-body-right-panel">
      <div class="stream-tab-body-right-panel-header">ADDITIONAL SETTINGS</div>
      <div class="stream-tab-body-right-panel-body">
        <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Allow payment</div>
          </div>
          <div class="filed-options">
            <b-switch v-model="form.allow_payment"> </b-switch>
          </div>
        </div>
        <!-- <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Keep stream as video</div>
          </div>
          <div class="filed-options">
            <b-switch v-model="form.keep_video"></b-switch>
          </div>
        </div> -->
        <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Show views</div>
          </div>
          <div class="filed-options">
            <b-switch v-model="form.show_views"> </b-switch>
          </div>
        </div>
        <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Allow chat</div>
          </div>
          <div class="filed-options">
            <b-switch v-model="form.allow_chat"> </b-switch>
          </div>
        </div>
        <div class="stream-details-item padding space-between">
          <div class="stream-details-content">
            <div class="field-value">Allow super chat</div>
          </div>
          <div class="filed-options">
            <b-switch v-model="form.allow_super_chat"> </b-switch>
          </div>
        </div>
        <div class="donation-sessions-container" v-if="form.allow_super_chat">
          <div class="donation-sessions-input">
            <b-select placeholder="Select donation" v-model="form.donationId">
              <option :value="null">None</option>
              <option v-for="item in donationSessions" :value="item.id">{{ item.title }}</option>
            </b-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    streamKey() {
      return this.form.stream_key;
    }
  },
  data: () => ({
    donationSessions: [],
    loading_donation_session: false,
  }),
  watch: {
    form: {
      handler: function (val) {
        console.log(val);
        this.updateSettings();
      },
      deep: true,
    },
  },
  mounted() {
    let vm = this;
    vm.getMyDonationSessions();
  },
  methods: {
    getMyDonationSessions() {
      let vm = this;
      vm.loading_donation_session = true;
      vm.$store
        .dispatch("DONATE_GET_ALL_DONATION_SESSION")
        .then((response) => {
          vm.loading_donation_session = false;
          vm.donationSessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_donation_session = false;
        });
    },
    updateSettings() {
      let vm = this;
      vm.$emit("updated", vm.form);
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Copy successfully!",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.stream-tab-body {
  height: calc(100% - 400px);
  width: 100%;
  display: flex;

  @media (max-width: 650px) {
    height: unset;
  }

  @media (max-width: 537px) {
    flex-direction: column;
    height: unset !important;

    .stream-tab-body-left-panel {
      width: 100% !important;
    }

    .stream-tab-body-right-panel {
      width: 100% !important;
    }
  }

  .stream-tab-body-left-panel {
    height: fit-content;
    width: 50%;
    border-right: 1px solid #ddd;

    @media (max-width: 650px) {
      height: unset;
    }

    .stream-tab-body-left-panel-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #ddd;
    }

    .stream-tab-body-left-panel-body {
      height: calc(100% - 50px);
      overflow-y: auto;

      @media (max-width: 650px) {
        height: unset;
      }

      .stream-settings-widget-option {
        padding: 0px 10px;
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        .stream-settings-widget-option-title {
          font-size: 12px;
          color: #797979;
        }

        .stream-settings-widget-option-body {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .stream-settings-option-left-panel {
            width: 100%;
            padding-right: 10px;

            .stream-details-input {
              width: 100%;
              height: 20px;
              border: none;
              border-radius: 5px;
              padding: 0px 0px;
            }

            .stream-details-textarea {
              width: 100%;
              height: 100px;
              border: 1px solid #ddd;
              border-radius: 5px;
              padding: 0px 0px;
            }
          }

          .stream-settings-option-right-panel {
            .stream-details-options {}
          }
        }
      }
    }
  }

  .stream-tab-body-right-panel {
    height: 100%;
    width: 50%;
    height: fit-content;
    border-right: 1px solid #ddd;

    @media (max-width: 650px) {
      height: unset;
    }

    .stream-tab-body-right-panel-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #ddd;
    }

    .stream-tab-body-right-panel-body {
      height: calc(100% - 50px);
      overflow-y: auto;

      @media (max-width: 650px) {
        height: unset;
      }

      .donation-sessions-container {
        padding: 0px 10px;

        .donation-sessions-input {
          margin-top: -18px;
          width: 100%;
        }
      }
    }
  }
}
</style>